module.exports = __webpack_public_path__ + "static/img/ls44.afaaa60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls44.png
// module id = WQ04
// module chunks = 12